import createCrudVuexModule from "@/store/crud";

const criteria = {
  department: null,
  process: null,
  datasource: null,
  dataCategory: null,
  data: null,
  datasubject: null,

  //

  directCollectMethod: null,
  otherCollectMethod: null,
  electronicArchive: null,
  electronicStorage: null,
  electronicStoragePeriod: null,
  physicalArchive: null,
  physicalStorage: null,
  physicalStoragePeriod: null,
  disposalMethod: null,
  dataAccessor: null,
  processingPurpose: null,
  processingLegalReason: null,
  transferingPurpose: null,
  transferingLegalReason: null,
  transferingMethod: null,
  receiverGroup: null,
  previousReceiverGroup: null, //yalnızca transfering recommendation için kullanıldı
  thirdParty: null,
  datasubjectRight: null,
};

export const inventoryFilter = createCrudVuexModule({
  namespaced: true,
  path: "/gdpr/inventory",
  // persistent: ["criteria"],

  state: {
    criteria: {
      ...criteria,
    },
  },
  getters: {
    criteria: (state) => state.criteria,
  },
  mutations: {
    criteria: (state, value) => (state.criteria = value),

    department: (state, value) => (state.criteria.department = value ? { _id: value._id, name: value.name } : null),
    process: (state, value) => (state.criteria.process = value ? { _id: value._id, name: value.name } : null),
    datasource: (state, value) => (state.criteria.datasource = value ? { _id: value._id, name: value.name } : null),
    dataCategory: (state, value) => (state.criteria.dataCategory = value ? { _id: value._id, name: value.name } : null),
    data: (state, value) => (state.criteria.data = value ? { _id: value._id, name: value.name } : null),
    datasubject: (state, value) => (state.criteria.datasubject = value ? { _id: value._id, name: value.name } : null),
    //
    directCollectMethod: (state, value) => (state.criteria.directCollectMethod = value ? { _id: value._id, name: value.name } : null),
    otherCollectMethod: (state, value) => (state.criteria.otherCollectMethod = value ? { _id: value._id, name: value.name } : null),
    electronicArchive: (state, value) => (state.criteria.electronicArchive = value ? { _id: value._id, name: value.name } : null),
    electronicStorage: (state, value) => (state.criteria.electronicStorage = value ? { _id: value._id, name: value.name } : null),
    electronicStoragePeriod: (state, value) => (state.criteria.electronicStoragePeriod = value),
    physicalArchive: (state, value) => (state.criteria.physicalArchive = value ? { _id: value._id, name: value.name } : null),
    physicalStorage: (state, value) => (state.criteria.physicalStorage = value ? { _id: value._id, name: value.name } : null),
    physicalStoragePeriod: (state, value) => (state.criteria.physicalStoragePeriod = value),
    disposalMethod: (state, value) => (state.criteria.disposalMethod = value ? { _id: value._id, name: value.name } : null),
    dataAccessor: (state, value) => (state.criteria.dataAccessor = value ? { _id: value._id, name: value.name } : null),
    processingPurpose: (state, value) => (state.criteria.processingPurpose = value ? { _id: value._id, name: value.name } : null),
    processingLegalReason: (state, value) => (state.criteria.processingLegalReason = value ? { _id: value._id, name: value.name } : null),
    transferingPurpose: (state, value) => (state.criteria.transferingPurpose = value ? { _id: value._id, name: value.name } : null),
    transferingLegalReason: (state, value) => (state.criteria.transferingLegalReason = value ? { _id: value._id, name: value.name } : null),
    transferingMethod: (state, value) => (state.criteria.transferingMethod = value ? { _id: value._id, name: value.name } : null),
    receiverGroup: (state, value) => (state.criteria.receiverGroup = value ? { _id: value._id, name: value.name } : null),
    previousReceiverGroup: (state, value) => (state.criteria.previousReceiverGroup = value ? { _id: value._id, name: value.name } : null),
    thirdParty: (state, value) => (state.criteria.thirdParty = value ? { _id: value._id, name: value.name } : null),
    datasubjectRight: (state, value) => (state.criteria.datasubjectRight = value ? { _id: value._id, name: value.name } : null),

    clear: (state, value) => (state.criteria = { ...criteria }),
  },
  actions: {},
});
